import { signOutFromFirebase } from '../../services/firebase/firebaseAuth';
import {
  stopFilteredNotificationsListener,
  stopReadAllBeforeListener,
  stopUnseenCountListener,
} from '../../services/firebase/notificationsService';
import { clearNotifications } from '../slices/notifications.slice';
import { setFirebaseUid } from '../slices/user.slice';
import type { AppThunk } from '../store';

function firebaseCleanup(): AppThunk {
  return (dispatch) => {
    stopFilteredNotificationsListener();
    stopReadAllBeforeListener();
    stopUnseenCountListener();
    dispatch(clearNotifications());
    dispatch(setFirebaseUid(null));
    signOutFromFirebase().catch((err) => {
      // eslint-disable-next-line no-console
      console.error('[Firebase] Sign out failed:', err);
    });
  };
}

export default firebaseCleanup;
